import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { UserIcon2, DocumentIcon2, RocketIcon, DollarIcon, LockIcon } from '../components/shared/Icons';
import DocPolicies from './DocPolicies';
import { cssUrl } from '../utils/cssVersion';
import PersonalDetails from './PersonalDetails';
import ToOnboarding from './ToOnboarding';
import MobileTraining from '../components/training/MobileTraining';
import ChangePassword from './ChangePassword';
import ResignationForm from './ResignationForm';
import FilteredPayments from '../components/payments/FilteredPayments';






const TABS = [
  {
    id: 'personal',
    label: 'Personal',
    
  },
  {
    id: 'dochub',
    label: 'On-Boarding',
    
  },
  
  
];



const DOCHUB_INNER = [
  { id: 'snldocs', label: 'Policies', icon: <DocumentIcon2 />, component: DocPolicies },
  { id: 'toonboarding', label: 'Doc-Hub', icon: <UserIcon2/>, component: () => <ToOnboarding userType="Existing" /> },
  { id: 'training', label: 'Training', icon: <RocketIcon />, component: MobileTraining },
  
  
];

const ONBOARD_INNER = [
  { id: 'payments', label: 'Money', icon: <DollarIcon />, component: FilteredPayments },
  { id: 'personals', label: 'User Details', icon: <UserIcon2 />, component: PersonalDetails },
  { id: 'password', label: 'Password', icon: <LockIcon />, component: ChangePassword },
  { id: 'resignation', label: 'Resignation', icon: <UserIcon2 />, component: ResignationForm },
  
];

const SuperOnboardPaged = () => {
  const [activeTab, setActiveTab] = useState("personal");
  const { homeAccent } = useUser();

  


  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'personal' && <InnerTabsd tabs={ONBOARD_INNER} defaultId="payments" />}
        {activeTab === 'dochub' && <InnerTabsd tabs={DOCHUB_INNER} defaultId="snldocs"/>}
        
        
      </div>
    </div>
  );
};



export default SuperOnboardPaged;